var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = theme.moneyFormat;
Shopify.customFormatMoney = function (cents, format) {
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || theme.moneyFormat);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

function isOverflown(element) {
  return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}

function getRandom(arr, n) {
  var result = new Array(n),
      len = arr.length,
      taken = new Array(len);
  if (n > len)
      throw new RangeError("getRandom: more elements taken than available");
  while (n--) {
      var x = Math.floor(Math.random() * len);
      result[n] = arr[x in taken ? taken[x] : x];
      taken[x] = --len in taken ? taken[len] : len;
  }
  return result;
}

function check_if_elements_overflow_horizontally() {
  $('[data-can-overflow-horizontally]').each(function () {
    if (isOverflown($(this)[0])) {
      $(this).addClass('overflown');
    } else {
      $(this).removeClass('overflown');
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  if(sessionStorage.collection_grid_mobile_layout) {
    layout_value = sessionStorage.collection_grid_mobile_layout;
    $('[data-change-mobile-layout]').removeClass('selected');
    $(`[data-change-mobile-layout="${layout_value}"]`).addClass('selected');
    $('[data-mobile-layout]').attr('data-mobile-layout',layout_value);
  }

  $(document).on('click', '[data-change-mobile-layout]', function(e) {
    layout_value = $(this).data('change-mobile-layout');
    $('[data-change-mobile-layout]').removeClass('selected');
    $(`[data-change-mobile-layout="${layout_value}"]`).addClass('selected');
    $('[data-mobile-layout]').attr('data-mobile-layout',layout_value);
    sessionStorage.collection_grid_mobile_layout = layout_value;
  });

  $(document).on('click', '[data-toggle-collapsible]', function(e) {
    collapsible_parent_container = $(this).parents('[data-collapsible-container]');
    $(this).toggleClass('opened');
    collapsible_parent_container.find('[data-collapsible-content]').slideToggle();
  });


  $(document).on('click', '[data-toggle-popup]', function(e) {
    e.preventDefault();
    popupName = $(this).data('toggle-popup');
    $(`[data-popup-name="${popupName}"]`).toggleClass('opened');
    $('body').toggleClass('popup-opened');
  });

  check_if_elements_overflow_horizontally();

  $(window).on('resize', check_if_elements_overflow_horizontally);

  $(document).on('mousedown', '[data-can-overflow-horizontally].overflown', function (event) {
    if ($(event.target).parents('[data-can-overflow-horizontally]').length) {
        element = $(event.target).parents('[data-can-overflow-horizontally]');
    } else {
        element = $(event.target);
    }
    element.data('down', true).data('x', event.clientX).data('scrollLeft', element[0].scrollLeft).addClass("grabbed");
  });

  $(document).on('mouseup', '[data-can-overflow-horizontally].overflown', function (event) {
    if ($(event.target).parents('[data-can-overflow-horizontally]').length) {
        element = $(event.target).parents('[data-can-overflow-horizontally]');
    } else {
        element = $(event.target);
    }
    element.data('down', false).removeClass("grabbed").removeClass('dragging');
  });

  $(document).on('mousemove', '[data-can-overflow-horizontally].overflown', function (event) {
    if ($(event.target).parents('[data-can-overflow-horizontally]').length) {
        element = $(event.target).parents('[data-can-overflow-horizontally]');
    } else {
        element = $(event.target);
    }
    if (element.data('down') == true) {
        element[0].scrollLeft = element.data('scrollLeft') + element.data('x') - event.clientX;
        element.addClass('dragging');
    }
  });

  $(document).on('click', '[data-scroll-overflown-left]', function(e){
    e.preventDefault();
    var element_to_scroll = $(this).parents('[data-overflown-element-parent]').find('[data-can-overflow-horizontally]');
    var current_scroll = element_to_scroll[0].scrollLeft || 0;
    var child_element_width = element_to_scroll.children().first().outerWidth();
    element_to_scroll[0].scrollLeft = current_scroll - child_element_width;
  });

  $(document).on('click', '[data-scroll-overflown-right]', function(e){
    e.preventDefault();
    var element_to_scroll = $(this).parents('[data-overflown-element-parent]').find('[data-can-overflow-horizontally]');
    var current_scroll = element_to_scroll[0].scrollLeft || 0;
    var child_element_width = element_to_scroll.children().first().outerWidth();
    element_to_scroll[0].scrollLeft = current_scroll + child_element_width;
  });

  // Spins functionality
  $(document).on('click', '[data-toggle-spins-container]', function (e) {
    e.preventDefault();
    $('.product-spins-container').fadeToggle();
  });

  function update_product_spin() {
    variant_id = $('[data-product-select]').val();
    variant_spin = $(`[data-spin-variant-id="${variant_id}"]`);
    active_variant_spin = $('[data-spin-variant-id].active');
    if (variant_spin.length) {``
      if (active_variant_spin.data('src') != variant_spin.data('src')) {
        $('[data-toggle-spins-container]').fadeIn();
        variant_spin.addClass('active').siblings().removeClass('active').hide();
        if (!variant_spin.hasClass('Sirv')) {
          variant_spin.addClass('Sirv')
          $('.product-spins-wrapper').append(variant_spin.clone().fadeIn())
          variant_spin.remove();
        } else {
          variant_spin.fadeIn();
        }
      }
    }
  }

  $(document).on('update-product-spin', function () {
    update_product_spin();
  });

  $(document).on('change', '[data-product-select]', function () {
    update_product_spin();
  });

  // Product options

  function get_variants_with_same_options(option1, option2, option3) {
    product = JSON.parse($('[data-product-json]').html());
    available_variants = product.variants.filter(variant => {
      return variant.available == true;
    });

    variants_with_same_options = available_variants.filter(variant => {
      var will_return = false;
      if (variant.option1 && !will_return) {
        will_return = variant.option1 == option1;
      }
      if (variant.option2 && !will_return) {
        will_return = variant.option2 == option2;
      }
      if (variant.option3 && !will_return) {
        will_return = variant.option3 == option3;
      }
      return will_return;
    });

    return variants_with_same_options;
  }

  function get_variant_by_options(option1, option2, option3) {
    product = JSON.parse($('[data-product-json]').html());
    available_variants = product.variants.filter(variant => {
      return variant.available == true;
    });

    variant = available_variants.find(variant => {
      return variant.option1 == option1 && variant.option2 == option2 && variant.option3 == option3;
    });

    return variant;
  }

  function filter_product_options_based_on_variant_id(variant_id, parent_section, product) {
    current_variant = get_variant_by_id(variant_id, product);

    available_options = {
      option1: [],
      option2: [],
      option3: []
    };

    variants_with_same_options = get_variants_with_same_options(current_variant.option1, current_variant.option2, current_variant.option3);

    for (i = 1; i <= product.options.length; i++) {
      [...variants_with_same_options].forEach(variant => {
          available_options[`option${i}`].push(variant[`option${i}`]);
      });
      // Leaving only unique values
      available_options[`option${i}`] = [...new Set(available_options[`option${i}`])];
    }

    for (i = 1; i <= product.options.length; i++) {
      parent_section.find(`[data-option-index="option${i}"] [data-product-option]`).each(function () {
          value = $(this).data('option-value');
          if (i > 1) {
              if (available_options[`option${i}`].includes(value)) {
                  $(this).prop('disabled', false);
              } else {
                  $(this).prop('disabled', true);
              }
          }
      });
    }
  }

  $(document).on('click', '[data-product-option]', function () {
    parent_section = $(this).parents('.shopify-section');
    option_container = $(this).parents('[data-option-container]');
    option_container.find('[data-product-option]').removeClass('selected');
    new_value = $(this).data('option-value');
    option_container.find(`[data-option-value="${new_value}"]`).addClass('selected');

    option_container.attr('data-current-value', new_value);
    setTimeout(function(){
      update_main_selector(parent_section);
    }, 200);
  });

  $(document).on('click', '[data-combined-option]', function(e) {
    e.preventDefault();
    parent_section = $(this).parents('.shopify-section');
    combined_option_container = $(this).parents('[data-combined-option-container]');
    combined_option_container.find('[data-combined-option]').removeClass('selected');
    new_value = $(this).data('combined-option-value');
    combined_option_container.find(`[data-combined-option-value="${new_value}"]`).addClass('selected');

    combined_option_container.attr('data-combined-current-value', new_value);

    combined_indexes = combined_option_container.attr('data-combined-option-index').split(',');
    combined_values = combined_option_container.attr('data-combined-current-value').split(',');
    combined_indexes.forEach((option_index, index) => {
      parent_section.find(`[data-option-index="${option_index}"]`).attr('data-current-value', combined_values[index]);
      parent_section.find(`[data-option-index="${option_index}"]`).find('[data-product-option]').removeClass('selected');
      parent_section.find(`[data-option-index="${option_index}"]`).find(`[data-product-option][data-option-value="${combined_values[index]}"]`).addClass('selected');
    });
    setTimeout(function(){
      update_main_selector(parent_section);
    }, 200);
  });

  $(document).on('click', '[data-splitted-option]', function(e) {
    e.preventDefault();
    parent_section = $(this).parents('.shopify-section');
    splitted_option_container = $(this).parents('[data-splitted-option-container]');
    splitted_option_index = splitted_option_container.data('splitted-option-index');
    splitted_option_containers = parent_section.find(`[data-splitted-option-index="${splitted_option_index}"]`);

    splitted_option_container.find('[data-splitted-option]').removeClass('selected');
    new_value = $(this).data('splitted-option-value');
    splitted_option_container.find(`[data-splitted-option][data-splitted-option-value="${new_value}"]`).addClass('selected');

    splitted_option_container.attr('data-splitted-current-value', new_value);

    new_combined_value = '';

    splitted_option_containers.each(function(){
      new_combined_value += $(this).attr('data-splitted-current-value') + ' ';
    });

    new_combined_value = new_combined_value.trim();

    parent_section.find(`[data-option-index="${splitted_option_index}"]`).attr('data-current-value', new_combined_value);
    parent_section.find(`[data-option-index="${splitted_option_index}"]`).find('[data-product-option]').removeClass('selected');
    parent_section.find(`[data-option-index="${splitted_option_index}"]`).find(`[data-product-option][data-option-value="${new_combined_value}"]`).addClass('selected');

    setTimeout(function(){
      update_main_selector(parent_section);
    }, 200);
  });

  $(document).on('change', '[data-product-option-range-input], [data-product-option-input]', function() {
    parent_section = $(this).parents('.shopify-section');
    new_value = $(this).val() + $(this).data('product-option-additional-text');
    option_container = $(this).parents('[data-option-container]');
    option_container.attr('data-current-value', new_value);
    update_main_selector(parent_section);
  });

  $(document).on('click', '[data-change-grouped-product]', function() {
    if(!$(this).hasClass('selected')) {
      parent_section = $(this).parents('.shopify-section');
      grouped_option_container = $(this).parents('[data-grouped-product-option-container]');
      grouped_option_container.find('[data-change-grouped-product]').removeClass('selected');
      $(this).addClass('selected');
      template_suffix = $(this).data('template-suffix');
      new_value = $(this).data('grouped-product-option-value');
      product_handle = $(this).data('change-grouped-product');
      section_id = parent_section.attr('id').replace('shopify-section-','');


      parent_section.find('[data-grouped-product-option-selected-value]').html(new_value);
      if($(this).find('use').length) {
        parent_section.find('[data-grouped-product-option-selected-value-icon]').attr('xlink:href', $(this).find('use').attr('xlink:href'));
      }

      selected_variant_options = {};
      parent_section.find('[data-option-container]').each(function () {
        if(selected_variant_options[`${$(this).attr('data-option-index')}`]) {
          selected_variant_options[`${$(this).attr('data-option-index')}`] = $(this).attr('data-current-value') + " " + selected_variant_options[`${$(this).attr('data-option-index')}`];
        } else {
          selected_variant_options[`${$(this).attr('data-option-index')}`] = $(this).attr('data-current-value');
        }
      });

      console.log(selected_variant_options);

      if (template_suffix != 'fine-jewelry') {
        parent_section.find('[data-product-json]').html(parent_section.find(`[data-grouped-product-json="${new_value}"]`).html());

        new_variant = get_variant_by_options(selected_variant_options.option1, selected_variant_options.option2, selected_variant_options.option3);

        if(!new_variant) {
          variants_with_same_options = get_variants_with_same_options(selected_variant_options.option1, selected_variant_options.option2, selected_variant_options.option3);
          similar_variants_by_option1 = variants_with_same_options.filter(variant => {
            return variant.option1 == selected_variant_options.option1;
          });
          new_variant = similar_variants_by_option1[0];
        }

        url = `/products/${product_handle}?view=${template_suffix}&section_id=${section_id}&variant=${new_variant.id}`;

        replace_product_content(parent_section, url);
      } else {
        fetch(`/products/${product_handle}?view=${template_suffix}&section_id=${section_id}`, {
          method: 'GET',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(function(response) {
          return response.text();
        })
        .then(function(text) {
          grouped_product = $(text);
          parent_section.find('[data-product-json]').html(grouped_product.find('[data-product-json]').html());

          new_variant = get_variant_by_options(selected_variant_options.option1, selected_variant_options.option2, selected_variant_options.option3);

          if(!new_variant) {
            variants_with_same_options = get_variants_with_same_options(selected_variant_options.option1, selected_variant_options.option2, selected_variant_options.option3);
            similar_variants_by_option1 = variants_with_same_options.filter(variant => {
              return variant.option1 == selected_variant_options.option1;
            });
            new_variant = similar_variants_by_option1[0];
          }

          url = `/products/${product_handle}?view=${template_suffix}&section_id=${section_id}&variant=${new_variant.id}`;

          replace_product_content(parent_section, url);
        });
      }
    }
  });

  function replace_product_content(parent_section, url) {
    fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(function(response) {
      return response.text();
    })
    .then(function(text) {
      grouped_product = $(text);
      if(parent_section.find('[data-variants-metafields-json]').length) {
        parent_section.find('[data-variants-metafields-json]').html(grouped_product.find('[data-variants-metafields-json]').html());
      }

      if(parent_section.find('#kcyor-setting-info').length) {
        parent_section.find('#kcyor-setting-info').html(grouped_product.find('#kcyor-setting-info').html());
      }

      parent_section.find('.cpst-images-container').html(grouped_product.find('.cpst-images-container').html());
      parent_section.find('.cpst-details-container').html(grouped_product.find('.cpst-details-container').html());

      parent_section.find('[data-grouped-product-option-container]').addClass('opened');
      parent_section.find('[data-options]').css('--opened-item-index', parent_section.find('[data-grouped-product-option-container]').index());
      parent_section.find('[data-options-container]').addClass('popup-opened');

      init_product_main_slider();

      var queryParams = new URLSearchParams(window.location.search);
      var newUrl = window.location.protocol + '//' + window.location.host + `/products/${product_handle}` + '?' + queryParams.toString();
      window.history.replaceState({ path: newUrl }, '', newUrl);

      update_main_selector(parent_section);
    });
  }

  function update_main_selector(parent_section) {
    var product = get_product(parent_section);
    selected_variant_options = {};
    parent_section.find('[data-option-container]').each(function () {
      if(selected_variant_options[`${$(this).attr('data-option-index')}`]) {
        selected_variant_options[`${$(this).attr('data-option-index')}`] = $(this).attr('data-current-value') + " " + selected_variant_options[`${$(this).attr('data-option-index')}`];
      } else {
        selected_variant_options[`${$(this).attr('data-option-index')}`] = $(this).attr('data-current-value');
      }
    });

    if (parent_section.find('[data-combined-option-container]').length) {
      parent_section.find('[data-combined-option-container]').each(function() {
        combined_option_container = $(this);
        combined_indexes = combined_option_container.attr('data-combined-option-index').split(',');
        new_combined_value = '';
        combined_indexes.forEach((option_index, index) => {
          new_combined_value += selected_variant_options[option_index];
          if (index < combined_indexes.length - 1) {
            new_combined_value += ',';
          }
        });
        combined_option_container.attr('data-combined-current-value', new_combined_value);
        combined_option_container.find('[data-combined-option]').removeClass('selected');
        combined_option_container.find(`[data-combined-option][data-combined-option-value="${new_combined_value}"]`).addClass('selected');
      });
    }

    if (parent_section.find('[data-splitted-option-container]').length) {
      parent_section.find('[data-splitted-option-container]').each(function(){
        splitted_option_container = $(this);
        splitted_option_index = splitted_option_container.data('splitted-option-index');
        splitted_option_container.find('[data-splitted-option]').removeClass('selected');
        splitted_option_container.find('[data-splitted-option]').each(function(){
          splitted_option = $(this);
          if (selected_variant_options[splitted_option_index].includes(splitted_option.data('splitted-option-value'))) {
            splitted_option.addClass('selected');
            splitted_option_container.attr('data-splitted-current-value', splitted_option.data('splitted-option-value'));
          }
        });
      });
    }

    new_variant = get_variant_by_options(selected_variant_options.option1, selected_variant_options.option2, selected_variant_options.option3);
    if (new_variant) {
        value = new_variant.id;
        parent_section.find('[data-product-select]').val(value).trigger('change');
        var queryParams = new URLSearchParams(window.location.search);
        queryParams.set("variant", value);
        var newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + queryParams.toString();
        window.history.replaceState({ path: newUrl }, '', newUrl);
        update_add_to_cart_button(parent_section.find('[data-product-select]'), parent_section, product);
        filter_product_options_based_on_variant_id(value, parent_section, product);
    } else {
      variants_with_same_options = get_variants_with_same_options(selected_variant_options.option1, selected_variant_options.option2, selected_variant_options.option3);

      similar_variants_by_option1 = variants_with_same_options.filter(variant => {
          return variant.option1 == selected_variant_options.option1;
      });

      if (similar_variants_by_option1.length) {
        first_similar_variant = similar_variants_by_option1[0];
        if (first_similar_variant.option2) {
            parent_section.find(`[data-option-value="${first_similar_variant.option2}"]`).click();
        }

        if (first_similar_variant.option3) {
            parent_section.find(`[data-option-value="${first_similar_variant.option3}"]`).click();
        }
      } else {
        parent_section.find('[data-product-add-cart]').addClass('unavailable');
        parent_section.find('[data-product-add-cart]').prop('disabled', true);
        parent_section.find('[data-product-add-cart] [data-product-add-cart-text]').html(theme.strings.unavailable);
      }
    }
  }

  function update_add_to_cart_button(selector, parent_section, product) {
    variantId = selector.val();
    variant = get_variant_by_id(variantId, product);
    parent_section.find('[data-product-add-cart]').removeClass('unavailable');

    if(parent_section.find('[data-variants-metafields-json]').length) {
      variants_metafields = JSON.parse(parent_section.find('[data-variants-metafields-json]').html());
      selected_variant_metafields = variants_metafields[variantId];
      for (var [key, value] of Object.entries(selected_variant_metafields)) {
        var elementToUpdate = parent_section.find(`[data-variant-${key}]`);
        if(elementToUpdate.length && value) {
          elementToUpdate.html(value);
        }
      }
    }

    // Update prices
    parent_section.find('[data-product-price]').text(Shopify.customFormatMoney(variant.price));
    if(parent_section.find('klarna-placement').length) {
      parent_section.find('klarna-placement').attr('data-purchase-amount', variant.price);
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    }

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      parent_section.find('[data-product-compare-price]').show().text(Shopify.customFormatMoney(variant.compare_at_price));
      parent_section.find('[data-product-compare-price-difference-container]').show();
      parent_section.find('[data-product-compare-price-difference]').text(Shopify.customFormatMoney(variant.compare_at_price - variant.price));
    } else {
      parent_section.find('[data-product-compare-price]').hide();
      parent_section.find('[data-product-compare-price-difference-container]').hide();
    }

    if(parent_section.find('[data-klarna-price]').length) {
      parent_section.find('[data-klarna-price]').text(Shopify.customFormatMoney(variant.price / 4.0));
    }

    // Update button
    if (variant.available) {
      parent_section.find('[data-product-add-cart]').prop('disabled', false);
      parent_section.find('[data-product-add-cart] [data-product-add-cart-text]').html(theme.strings.addToCart);
    } else {
      parent_section.find('[data-product-add-cart]').prop('disabled', true);
      parent_section.find('[data-product-add-cart] [data-product-add-cart-text]').html(theme.strings.soldOut);
    }

    // Update product SKU
    if (variant.sku) {
      parent_section.find('[data-product-sku]:not(.stamped-product-reviews-badge)').html(variant.sku);
    }
    if(variant.featured_image) {
      parent_section.find('.varImgLink').html(variant.featured_image.src);
    }

    // Update product details tab
    variant_options_string = [];
    variant.options.forEach(function (option_value, index) {
      option_index = index + 1;
      if (option_value && parent_section.find(`[data-variant-option${option_index}-value]`).length) {
        parent_section.find(`[data-variant-option${option_index}-value]`).html(option_value);

        if (parent_section.find(`[data-option-index="option${option_index}"] [data-option-value="${option_value}"] use`).length) {
          option_value_icon = parent_section.find(`[data-option-index="option${option_index}"] [data-option-value="${option_value}"] use`);
          parent_section.find(`[data-variant-option${option_index}-value-icon]`).attr('xlink:href', option_value_icon.attr('xlink:href'));
        }
      }

      if(parent_section.hasClass('custom-product-wedding-band-template') && option_index == 1) {
        purity_value = option_value.split(' ')[0];
        metal_value = option_value.replace(purity_value, '').trim();
        parent_section.find(`[data-variant-option${option_index}-value-purity]`).html(purity_value);

        parent_section.find(`[data-variant-option${option_index}-value-metal]`).html(metal_value);
        if (parent_section.find(`[data-option-index="option${option_index}"] [data-option-value="${metal_value}"] use`).length) {
          option_value_icon = parent_section.find(`[data-option-index="option${option_index}"] [data-option-value="${metal_value}"] use`);
          parent_section.find(`[data-variant-option${option_index}-value-metal-icon]`).attr('xlink:href', option_value_icon.attr('xlink:href'));
        }
      }

      variant_options_string.push(`[data-thumbnail-media-alt*="Option${index+1}:${option_value}"]`);
    });

    // Update main slider
    if (variant.featured_media) {
      media_id = variant.featured_media.id;
      media_alt = variant.featured_media.alt || product.title;
      if (media_alt.includes('data-')) {
        media_alt = media_alt.split(' data-')[0];
      }
      $('[data-thumbnail]').addClass('hidden');
      if(variant.options.length > 1) {
        $(`[data-thumbnail-media-alt="${media_alt}"], ${variant_options_string}`).removeClass('hidden');
      } else {
        $(`[data-thumbnail-media-alt="${media_alt}"]`).removeClass('hidden');
      }

      if(parent_section.find('[data-drop-a-hint-modal]')) {
        parent_section.find('[data-drop-a-hint-variant-image]').attr('data-src', variant.featured_media.preview_image.src).attr('src', variant.featured_media.preview_image.src);
        parent_section.find('[name="product_image"]').val(variant.featured_media.preview_image.src);
      }

      thumbnail = $(`[data-thumbnail-media-id='${media_id}']`);
      currently_visible_images = parent_section.find('[data-currently-visible-images]').attr('data-currently-visible-images');
      if (thumbnail.length) {
        if(currently_visible_images == 'images') {
          $('[data-thumbnail]').removeClass('active');
          thumbnail.addClass('active');
        } else {
          $('[data-spin-thumbnail]:not(.hidden)').addClass('active');
        }
        filter_main_images_slides(media_alt, $('[data-main-slider]').slick('getSlick'), variant, parent_section);
        slide_index = $(`[data-main-media-id="${media_id}"]`).index();
        $('[data-main-slider]').slick('slickGoTo', slide_index);
        if($('[data-thumbnails-slider]').length) {
          $('[data-thumbnails-slider]')[0].scrollTop = thumbnail.prevAll(':not(.hidden)').length * thumbnail.prevAll(':not(.hidden)').outerHeight(true);
        }
      }
    }
  }

  $(document).on('click', '[data-switch-product-images-to]', function(e) {
    parent_section = $(this).parents('.shopify-section');
    currently_visible_images = parent_section.find('[data-currently-visible-images]').attr('data-currently-visible-images');

    switch_to = $(this).data('switch-product-images-to');
    if(switch_to != currently_visible_images) {
      parent_section.find('[data-currently-visible-images]').attr('data-currently-visible-images', switch_to);
      $('[data-switch-product-images-to]').removeClass('active');
      $(`[data-switch-product-images-to="${switch_to}"]`).addClass('active');
      switch_to_element =  parent_section.find(`[data-product-${switch_to}]`)
      parent_section.find('[data-switchable-images-container]').hide();
      switch_to_element.fadeIn();

      if(typeof switch_to_element.attr('data-has-slider-inside') !== typeof undefined && switch_to_element.attr('data-has-slider-inside') !== false) {
        slider_to_refresh = switch_to_element.data('has-slider-inside');
        switch_to_element.find(`[${slider_to_refresh}]`).slick('refresh');
      }
    }
  });

  function init_product_main_slider() {
    $('[data-main-slider]').on('init', function (event, slick) {
      if ($('[data-product-select]').length) {
        parent_section = $('[data-main-slider]').parents('.shopify-section');
        product = get_product(parent_section);
        variant_id = $('[data-product-select]').val();
        if(variant_id) {
          variant = get_variant_by_id(variant_id, product);
          if (variant.featured_media) {
            media_alt = variant.featured_media.alt || product.title;
          } else {
            media_alt = product.title;
          }
          if (media_alt.includes('data-')) {
            media_alt = media_alt.split(' data-')[0];
          }
          filter_main_images_slides(media_alt, slick, variant, parent_section);
        }
      }
    });

    $('[data-main-slider]').slick({
        infinite: true,
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        mobileFirst: true
    });

    $('[data-main-slider]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      media_id = $(slick.$slides[nextSlide]).data('main-media-id');
      thumbnail = $(`[data-thumbnail-media-id="${media_id}"]`);
      parent_section = $(slick.$slider).parents('.shopify-section');
      currently_visible_images = parent_section.find('[data-currently-visible-images]').attr('data-currently-visible-images');
      if(currently_visible_images == 'images') {
        thumbnail.addClass('active').siblings().removeClass('active');
      }
      if($('[data-thumbnails-slider]').length) {
        $('[data-thumbnails-slider]')[0].scrollTop = thumbnail.prevAll(':not(.hidden)').length * thumbnail.prevAll(':not(.hidden)').outerHeight(true);
      }
  	});
  }

  init_product_main_slider();

  $(document).on('click','[data-thumbnail]', function () {
    parent_section = $(this).parents('.shopify-section');
    currently_visible_images = parent_section.find('[data-currently-visible-images]').attr('data-currently-visible-images');
    $('[data-thumbnail]').removeClass('active');
    $(this).addClass('active');
    if(typeof $(this).attr('data-main-images-thumbnail') !== typeof undefined && $(this).attr('data-main-images-thumbnail') !== false) {
      media_id = $(this).data('thumbnail-media-id');
      slide_index = $(`[data-main-media-id="${media_id}"]`).index() - 1;
      $('[data-main-slider]').slick('slickGoTo', slide_index);
      if($('[data-thumbnails-slider]').length) {
        $('[data-thumbnails-slider]')[0].scrollTop = $(this).prevAll(':not(.hidden)').length * $(this).prevAll(':not(.hidden)').outerHeight(true);
      }
      if(currently_visible_images != 'images') {
        switch_to_element = parent_section.find(`[data-product-images]`)
        parent_section.find('[data-switchable-images-container]').hide();
        switch_to_element.fadeIn();
        parent_section.find('[data-currently-visible-images]').attr('data-currently-visible-images', 'images')

        $('[data-main-slider]').slick('refresh');
      }
    } else {
      if(currently_visible_images != 'spins') {
        switch_to_element = parent_section.find(`[data-product-spins]`)
        parent_section.find('[data-switchable-images-container]').hide();
        switch_to_element.fadeIn();
        parent_section.find('[data-currently-visible-images]').attr('data-currently-visible-images', 'spins')
      }
    }
  });

  $(document).on('click', '[data-toggle-setting-options]', function(e){
    e.preventDefault();
    parent_section= $(this).parents('.shopify-section');
    if(window.matchMedia('(min-width: 600px)').matches) {
      parent_section.find('[data-options-container').toggleClass('popup-opened');
    } else {
      parent_section.find('[data-options-container]').slideToggle();
      $(this).toggleClass('opened');
    }
  });

  $(document).on('click', '[data-toggle-setting-option]', function(e){
    e.preventDefault();
    $(this).parents('[data-item-option]').toggleClass('opened');
      if($(this).parents('[data-options]').find('[data-item-option].opened').length) {
      $(this).parents('[data-options]').css('--opened-item-index', $(this).parents('[data-options]').find('[data-item-option].opened').index());
    } else {
      $(this).parents('[data-options]').css('--opened-item-index', 0);
    }
  });

  $(document).on('click', '[data-checkout-now-button]', function(e) {
    e.preventDefault();
    var parent_form = $(this).parents('form');
    if(parent_form.is(":valid")) {
      addItemToCartAndCheckout(parent_form);
    } else {
      parent_form.find('[type="submit"]').click();
    }
  });

  $(document).on('click', '[data-open-thumbnails-popup]', function(e) {
    e.preventDefault();
    $('body').addClass('thumbnails-popup-opened');
  });

  $(document).on('click', '[data-secondary-add-to-cart-button]', function(e) {
    e.preventDefault();
    parent_form = $('[data-primary-add-to-cart-button]').parents('form');
    if (!parent_form.is(':valid')) {
       $('html, body').animate({
        scrollTop: parent_form.offset().top
      }, 800, function(){
        $('[data-primary-add-to-cart-button]').click();
      });
    } else {
      $('[data-primary-add-to-cart-button]').click();
    }
  });

  $(document).on('click', '[data-close-thumbnails-popup]', function(e) {
    e.preventDefault();
    $('body').removeClass('thumbnails-popup-opened');
  });

  init_you_may_also_like();
  init_complete_your_look();

  function init_you_may_also_like() {
    if($('[data-you-may-also-like]').length) {
      var initial_set_of_products = $('[data-you-may-also-like] [data-related-product-item]');
      var amount_of_products_to_pick = parseInt($('[data-you-may-also-like]').data('products-to-show'));
      var selected_set_of_products = getRandom(initial_set_of_products, Math.min(amount_of_products_to_pick, initial_set_of_products.length));
      $('[data-you-may-also-like]').html(selected_set_of_products);
    }
  }

  function init_complete_your_look() {
    if($('[data-complete-your-look]').length) {
      $('[data-complete-your-look]').flickity({
        freeScroll: true,
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        cellAlign: 'left',
        watchCSS: true
      })
    }
  }

  function filter_main_images_slides(media_alt, slick, variant, parent_section) {
    slick.unfilterSlides();
    variant_options_string = [];
    variant.options.forEach((option, index) => {
      variant_options_string.push(`[data-media-alt*="Option${index+1}:${option}"]`);
    });
    variant_options_string = variant_options_string.join(',');
    if(variant.options.length > 1) {
      slick.filterSlides(`[data-media-alt="${media_alt}"],${variant_options_string}`);
    } else {
      slick.filterSlides(`[data-media-alt="${media_alt}"]`);
    }

    if (variant.featured_media) {
      selected_slide = slick.$slider.find(`[data-main-media-id="${variant.featured_media.id}"]:not('.slick-cloned')`);
      slide_index = 0;
      $.each(slick.$slides, function (index, value) {
        if ($(value) == selected_slide) {
          slide_index = index;
        }
      });
      slick.goTo(slide_index);
    }
  }

  function get_product(parent_section) {
    return JSON.parse(parent_section.find('[data-product-json]').html());
  }

  function get_variant_by_id(variant_id, product) {
    var result = product.variants.filter(obj => {
        return obj.id == variant_id;
    });
    var variant = result[0];
    return variant;
  }

  function addItemToCartAndCheckout(form) {
    fetch(theme.cartRoutes.cartAddUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: form.serialize()
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(json) {
      if (json.status && json.status !== 200) {
        // all available product inventory already in cart throw an error, but redirect to checkout anyway
        var error = new Error(json.description);
        error.isFromServer = true;
        throw error;
      }
      window.location.href = theme.cartRoutes.checkoutUrl;
    })
    .catch(function(error) {
      // eslint-disable-next-line no-console
      console.log(error);
      window.location.href = theme.cartRoutes.checkoutUrl;
    });
  }

  function set_header_height_variable() {
    header_height = $('#shopify-section-ziv-header').outerHeight(true);
    $('body').get(0).style.setProperty("--header-h", header_height + 'px');
  }

  setTimeout(set_header_height_variable, 0);

  const sticky_header = document.querySelector('.header-sticky');

  const observer = new IntersectionObserver(
    ([e]) => {
      e.target.classList.toggle('isSticky', e.intersectionRatio < 1);
      setTimeout(set_header_height_variable, 300);
    },
    {
      rootMargin: '-1px 0px 0px 0px',
      threshold: [1]
    }
  );

  observer.observe(sticky_header)

  function check_primary_add_to_cart_visibility() {
    if($('[data-primary-add-to-cart-button]').length) {
      var window_scroll = $(window).scrollTop();
      var button_bottom_point = $('[data-primary-add-to-cart-button]').offset().top + $('[data-primary-add-to-cart-button]').outerHeight(true);
      if(window_scroll > button_bottom_point){
        $('body').addClass('primary-add-to-cart-not-visible');
      } else {
        $('body').removeClass('primary-add-to-cart-not-visible');
      }
    }
  }

  setTimeout(check_primary_add_to_cart_visibility, 0)

  $(window).on('scroll resize', function () {
    set_header_height_variable();
    check_primary_add_to_cart_visibility();
  });


  function init_announcement_bar_slider() {
    if ($('.cab-slider.apply-slider').length) {
      slider_settings = $('.cab-slider.apply-slider').data('slider-settings');
      $('.cab-slider.apply-slider').slick(slider_settings);
    }
  }

  init_announcement_bar_slider()


  function init_mobile_announcement_bar_slider() {
    if ($('.mobile-menu-announcement-content.apply-slider').length) {
      slider_settings = $('.mobile-menu-announcement-content.apply-slider').data('slider-settings');
      $('.mobile-menu-announcement-content.apply-slider').slick(slider_settings);
    }
  }

  init_mobile_announcement_bar_slider()
  $(document).on('click', '[data-show-child-links]', function(e) {
    e.preventDefault();
    var link_handle = $(this).data('show-child-links');
    $(this).parent().addClass('active').siblings().removeClass('active');
    $(`[data-child-links="${link_handle}"]`).fadeIn().siblings().hide();
  });

  $(document).on('click', '[data-open-drop-a-hint-modal]', function(e) {
    e.preventDefault();
    $('[data-drop-a-hint-modal]').addClass('visible');
  });

  $(document).on('click', '[data-close-drop-a-hint-modal]', function(e) {
    e.preventDefault();
    $('[data-drop-a-hint-modal]').removeClass('visible');
  });

  $(document).on('submit', '[data-drop-a-hint-form]', function(e) {
    e.preventDefault();
    form_object = Object.fromEntries(new FormData(this));
    timestamp = new Date().getTime();
    api_url = 'https://a.klaviyo.com/api/track';
    data_for_dropped_a_hint = {
      "token":"TahfgE",
      "event": "Dropped A Hint",
      "customer_properties": {
        "$email": form_object.sender_email
      },
      "properties": {
        "$event_id": btoa(form_object.sender_email) + '_' + timestamp,
        "SenderName": form_object.sender_name,
        "SenderEmail": form_object.sender_email,
        "RecipientName": form_object.recipient_name,
        "RecipientEmail": form_object.recipient_email,
        "URL": window.location.href,
        "ImageURL": form_object.product_image,
        "ProductTitle": form_object.product_title
      },
      "$time": timestamp
    }
    data_for_received_dropped_a_hint = {
      "token":"TahfgE",
      "event": "Received Dropped Hint",
      "customer_properties": {
        "$email": form_object.recipient_email
      },
      "properties": {
        "$event_id": btoa(form_object.recipient_email) + '_' + timestamp,
        "SenderName": form_object.sender_name,
        "SenderEmail": form_object.sender_email,
        "RecipientName": form_object.recipient_name,
        "RecipientEmail": form_object.recipient_email,
        "URL": window.location.href,
        "ImageURL": form_object.product_image,
        "ProductTitle": form_object.product_title
      },
      "$time": timestamp
    }

    var dropped_a_hint_options = {
      method: 'POST',
      headers: {Accept: 'text/html', 'Content-Type': 'application/x-www-form-urlencoded'},
      body: new URLSearchParams({
        data: JSON.stringify(data_for_dropped_a_hint)
      })
    };
    fetch(api_url, dropped_a_hint_options)


    var received_dropped_a_hint_options = {
      method: 'POST',
      headers: {Accept: 'text/html', 'Content-Type': 'application/x-www-form-urlencoded'},
      body: new URLSearchParams({
        data: JSON.stringify(data_for_received_dropped_a_hint)
      })
    };
    fetch(api_url, received_dropped_a_hint_options)

    $('[data-drop-a-hint-form]').hide();
    $('[data-drop-a-hint-form-success]').fadeIn();
    $('[data-drop-a-hint-preview]').click();
  });

  $(document).on('click', '[data-drop-a-hint-preview]', function(e) {
    e.preventDefault();
    recipient_name = $('[name="recipient_name"]').val();
    sender_name = $('[name="sender_name"]').val();

    $('[data-recipient-name]').html(recipient_name).addClass('not-empty');
    if(!recipient_name) $('[data-recipient-name]').removeClass('not-empty');

    $('[data-sender-name]').html(sender_name).addClass('not-empty');
    if(!sender_name) $('[data-sender-name]').removeClass('not-empty');
  });

  $(document).on('input', '[data-education-item-range-slider]', function(){
    percentage_value = (this.value-this.min)/(this.max-this.min)*100;
    this.style.setProperty('--current-value-percentage', percentage_value + '%');

    education_item_name = $(this).data('education-item-range-slider');

    education_item = $(this).parents('[data-education-item]');

    valueToFloat = parseFloat(this.value).toFixed(1);
    education_item.attr('data-education-item-current-value', valueToFloat);

    label = valueToFloat;
    if(education_item.find('[data-values-to-labels]').length) {
      labels = JSON.parse(education_item.find('[data-values-to-labels]').html());
      if(labels[valueToFloat]) {
        label = labels[valueToFloat]
      }
    }

    $(`[data-education-item-selected-label="${education_item_name}"]`).html(label);
  });

  $(document).on('click', '[data-show-education-item]', function(e){
    e.preventDefault();
    if($(this).hasClass('active')) return;
    education_item = $(this).data('show-education-item');
    $(this).addClass('active').siblings().removeClass('active');
    $(`[data-education-item="${education_item}"]`).addClass('active').siblings().removeClass('active');
  });

  $(document).on('click', '[data-toggle-education-popup]', function(e) {
    e.preventDefault();
    $('[data-education-popup]').toggleClass('opened');
    education_item_name = $(this).data('toggle-education-popup');
    if(!education_item_name.length) return
    $(`[data-show-education-item="${education_item_name}"]`).addClass('active').siblings().removeClass('active');
    $(`[data-education-item="${education_item_name}"]`).addClass('active').siblings().removeClass('active');
  });

  $(document).on('click', '[data-open-stone-not-available-popup]', function(e) {
    e.preventDefault();
    open_stone_not_available_popup();
  });

  $(document).on('click', '[data-sold-out="true"] .mobile-status', function(e) {
    e.preventDefault();
    e.stopPropagation();
    open_stone_not_available_popup();
  });

  $(document).on('click', '[data-sold-out="true"] :not(.mobile-status)', function(e) {
    if(!(window.matchMedia("(min-width: 600px)").matches)) return;
    if($(e.target).parents('.remove-btn').length || $(e.target).hasClass('.remove-btn')) return;
    e.preventDefault();
    e.stopPropagation();
    open_stone_not_available_popup();
  });

  function open_stone_not_available_popup() {
    $('[data-stone-not-available-popup]').addClass('opened');
  }

  $(document).on('click', '[data-close-stone-not-available-popup]', function(e) {
  	e.preventDefault();
  	$('[data-stone-not-available-popup]').removeClass('opened');
  });

  $(document).on('click', '[data-toggle-diamond-wizard-popup]', function(e) {
    e.preventDefault();
    $('[data-diamond-wizard-popup]').toggleClass('opened');
  });

  $(document).on('click', '[data-change-diamond-wizard-step]', function(e) {
    e.preventDefault();
    change = parseInt($(this).data('change-diamond-wizard-step'));
    current_step = parseInt($('[data-diamond-wizard-content]').attr('data-current-step'));
    $('[data-diamond-wizard-content]').attr('data-current-step', current_step + change);
    $('[data-diamond-wizard-content]').css('--current-step', current_step + change);
  });

  $(document).on('input', '[data-diamond-wizard-price-slider]', function(){
    percentage_value = (this.value-this.min)/(this.max-this.min)*100;
    $('[data-diamond-wizard-slider-wrapper]').css('--current-value-percentage', percentage_value + '%');
    formatted_price = Shopify.customFormatMoney(this.value * 100);
    $('[data-diamond-wizard-slider-label]').html(theme.diamondWizard.price_label.replace('[price]', formatted_price));
  });

  $(document).on('click', '[data-diamond-wizard-set-slider-value]', function(e) {
    e.preventDefault();
    new_value = parseInt($(this).data('diamond-wizard-set-slider-value'));
    $('[data-diamond-wizard-price-slider]').val(new_value).trigger('input');
  });

  $(document).on('click', '[data-reset-diamond-wizard]', function() {
    $('[data-diamond-wizard-price-slider]').val(2500).trigger('input');
  });

  function init_featured_products_slider() {
    $(".fp-item-slider-wrapper:not('.slick-initialized')").slick({
      mobileFirst: true,
      slidesToScroll: 1,
      slidesToShow: 1,
      arrows: false,
      dots: true,
      swipeToSlide: true,
      prevArrow: "<button type='button' class='slick-prev fp-item-slider-arrow fp-item-slider-prev-arrow'><svg class='fp-item-slider-button-icon' aria-hidden='true' focusable='false'> <use xlink:href='#chevron-left'></use></svg></button>",
      nextArrow: "<button type='button' class='slick-next fp-item-slider-arrow fp-item-slider-next-arrow'><svg class='fp-item-slider-button-icon' aria-hidden='true' focusable='false'> <use xlink:href='#chevron-right'></use></svg></button>",
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true
          }
        }
      ]
    });
  }

  if($('.fp-item-slider-wrapper').length) {
    init_featured_products_slider()
  }

  function init_eg_styles_slider() {
    $(".eg-styles-slider-wrapper:not('.slick-initialized')").slick({
      infinite: false,
      dots: false,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      mobileFirst: true,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 2
          }
        }
      ]
    });
  }

  if($('.eg-styles-slider-wrapper').length) {
    init_eg_styles_slider();
  }

  function init_eg_reviews_slider() {
    $('.eg-reviews-slider-wrapper').on('init', function(event, slick){
      $(this).parents('.eg-reviews-container').css('--total_slides',slick.$slides.length);
      $(this).parents('.eg-reviews-container').css('--current_slide',slick.currentSlide);
      $(this).parents('.eg-reviews-container').css('--slides_to_show',slick.options.slidesToShow);
    });
    $(".eg-reviews-slider-wrapper:not('.slick-initialized')").slick({
      infinite: false,
      dots: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      mobileFirst: true,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            adaptiveHeight: true,
            dots: false
          }
        },
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 3,
            adaptiveHeight: true,
            dots: false
          }
        }
      ]
    });
    $('.eg-reviews-slider-wrapper').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      $(this).parents('.eg-reviews-container').css('--current_slide',nextSlide);
    });

    $('.eg-reviews-slider-wrapper').on('setPosition', function(event, slick){
      $(this).parents('.eg-reviews-container').css('--slides_to_show',slick.options.slidesToShow);
    });
  }

  if($('.eg-reviews-slider-wrapper').length) {
    init_eg_reviews_slider();
  }

  function init_eg_shapes_slider() {
    $('.eg-shapes-slider-wrapper').on('init', function (event, slick) {
      parent_section = $(this).parents('.shopify-section');
      previousToCurrentSlideIndex = slick.currentSlide - 1;
      if (previousToCurrentSlideIndex < 0) {
        previousToCurrentSlideIndex = slick.$slides.length - 1;
      }
      slideBlockId = slick.$slides[previousToCurrentSlideIndex].dataset.blockId;
      parent_section.find(`[data-block-id="${slideBlockId}"]`).addClass('prev-to-center-slide');
    });
    $(".eg-shapes-slider-wrapper:not('.slick-initialized')").slick({
      infinite: true,
      dots: false,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      centerMode: true,
      centerPadding: '0px',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 5
          }
        }
      ]
    });
    $(".eg-shapes-slider-wrapper").on('beforeChange', function(event, slick, currentSlide, nextSlide){
      parent_section = $(this).parents('.shopify-section');
      parent_section.find(`[data-block-id]`).removeClass('prev-to-center-slide');
      currentSlideElement = slick.$slides[currentSlide];
      nextSlideElement = slick.$slides[nextSlide];
      parent_section.find(`[data-block-content-id="${currentSlideElement.dataset.blockId}"]`).hide();
      parent_section.find(`[data-block-content-id="${nextSlideElement.dataset.blockId}"]`).fadeIn();

      previousToCurrentSlideIndex = nextSlide - 1;
      if (previousToCurrentSlideIndex < 0) {
        previousToCurrentSlideIndex = slick.$slides.length - 1;
      }
      slideBlockId = slick.$slides[previousToCurrentSlideIndex].dataset.blockId;
      parent_section.find(`[data-block-id="${slideBlockId}"]`).addClass('prev-to-center-slide');
    });
  }

  if($('.eg-shapes-slider-wrapper').length) {
    init_eg_shapes_slider();
  }

  function init_featured_articles_slider() {
    $(".fas-items-wrapper:not('.slick-initialized')").slick({
      infinite: false,
      dots: false,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 1279,
          settings: {
            slidesToShow: 3
          }
        }
      ]
    });
  }

  if($('.fas-items-wrapper').length) {
    init_featured_articles_slider();
  }

  function init_index_ring_styles_slider() {
    $(".irs-items-wrapper:not('.slick-initialized')").slick({
      infinite: false,
      dots: false,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      mobileFirst: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 1279,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1439,
          settings: {
            slidesToShow: 4
          }
        }
      ]
    });
  }

  if($('.irs-items-wrapper').length) {
    init_index_ring_styles_slider();
  }

  $(document).on('click', '[data-slide-to]', function(e) {
    e.preventDefault();
    slide_direction = $(this).data('slide-to');
    parent_section = $(this).parents('.shopify-section');
    parent_section.find('[data-slick-slider]').slick( slide_direction);
  });

  $(document).on('click', '[data-show-more]', function(e) {
    e.preventDefault();
    blocks_to_open = $(this).data('blocks-to-open');
    parent_section = $(this).parents('[data-show-more-container]');
    elements_to_open = parent_section.find('[data-show-more-block].first-load-hidden').slice(0, blocks_to_open);
    elements_to_open.removeClass('first-load-hidden');
    remained_elements = parent_section.find('[data-show-more-block].first-load-hidden').length;
    if (remained_elements == 0){
      $(this).parent().remove();
    }
  });

  $(document).on('shopify:section:load', function (event) {
    if ($(event.target).hasClass('custom-announcement-bar-section')) {
      init_announcement_bar_slider();
    }
    if ($(event.target).hasClass('ziv-header-section')) {
      init_mobile_announcement_bar_slider();
    }
    if($(event.target).hasClass('custom-product-template')) {
      init_you_may_also_like();
      init_complete_your_look();
      init_product_main_slider();
    }
    if($(event.target).hasClass('featured-product-section')) {
      init_featured_products_slider();
    }
    if($(event.target).hasClass('eg-styles-section')) {
      init_eg_styles_slider();
    }
    if($(event.target).hasClass('eg-reviews-section')) {
      init_eg_reviews_slider();
    }
    if($(event.target).hasClass('eg-shapes-section')) {
      init_eg_shapes_slider();
    }
    if($(event.target).hasClass('featured-articles-section')) {
      init_featured_articles_slider();
    }
    if($(event.target).hasClass('index-ring-styles-section')) {
      init_index_ring_styles_slider();
    }
  });
});
